/**
 * Labstep
 *
 * @module components/Group/Settings/DefaultSignatureStatement
 * @desc DefaultSignatureStatement field update
 */

import { fieldGroupDefaultSignatureStatement } from 'labstep-web/components/Group/Form/fields';
import { FormShowEditText as ShowEditText } from 'labstep-web/core/Form/ShowEdit/Text';
import type React from 'react';
import type { GroupFormShowEditDefaultSignatureStatementProps } from './types';

export const GroupFormShowEditDefaultSignatureStatement: React.FC<
  GroupFormShowEditDefaultSignatureStatementProps
> = ({ group }) => (
  <ShowEditText
    entityName={group.entityName}
    entity={group}
    field={fieldGroupDefaultSignatureStatement}
  >
    {group.default_signature_statement}
  </ShowEditText>
);
